// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Explore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable } from 'mobx';
import { CHART_TYPE } from 'logic/data/Izenda.ChartDefaultConfig';


const dateType = {
  type: 'Date',
  color: '#1F3686',
  icon: 'icon-type-calendar'
};

const dimensionsType = {
  type: 'Dimensions',
  color: '#48B3D3',
  icon: 'icon-type-text'
};

const measuresType = {
  type: 'Measures',
  color: '#3574AC',
  icon: 'icon-type-no'
};

export default class Explore {
  @observable nlqDataandSchemaInfo;
  @observable activeTab;
  @observable searchString;
  @observable nlpDict;
  @observable suggestionList;
  @observable showResult;
  @observable ActiveProcess;
  @observable suggestionSearchList;
  @observable nlpDictList;
  @observable setResults;
  @observable setCurrentNumber;
  @observable isTobeSearch;
  @observable isMLError;
  @observable visualizationReportRequest;
  @observable nlqVisualizationRecommendationList;
  @observable nlqVisualizationReportDefinition;
  @observable nlqVisualizationRecords;
  @observable resultReportDefinition;
  @observable resultReportRecords;
  @observable visualizationRecommendationList;
  @observable enableNLQSearch = false;
  @observable loadCategoriesHiearchy;
  @observable loadDashboardCategoriesHiearchy;
  @observable OriginalLoadCategoriesHiearchy;
  @observable OriginalloadDashboardCategoriesHiearchy;
  @observable recentReportViewList;
  @observable noOfColumns;
  @observable noOfTotalRecords;
  // clone() {
  //   const data = toJS(this);
  //   const cloned = new Explore(data);
  //   return cloned;
  // }
  constructor() {
    const recommendedText = 'Recommended';
    this.nlqDataandSchemaInfo = null;
    this.activeTab = 1;
    this.searchString = '';
    this.nlpDict = '{}';
    this.suggestionList = [];
    this.showResult = false;
    this.ActiveProcess = 1;
    this.suggestionSearchList = [];
    this.setResults = [];
    this.nlpDictList = [];
    this.setCurrentNumber = -1;
    this.isTobeSearch = false;
    this.isMLError = false;
    this.visualizationReportRequest = null;
    this.nlqVisualizationRecommendationList = [];
    this.nlqVisualizationReportDefinition = null;
    this.nlqVisualizationRecords = null;
    this.resultReportDefinition = null;
    this.resultReportRecords = null;
    this.loadCategoriesHiearchy = [];
    this.OriginalLoadCategoriesHiearchy = [];
    this.loadDashboardCategoriesHiearchy = [];
    this.categoriesTypes = [];
    this.OriginalloadDashboardCategoriesHiearchy = [];
    this.recentReportViewList = [];
    this.noOfColumns = 0;
    this.noOfTotalRecords = 0;

    this.visualizationRecommendationList = [
      {
        chartType: CHART_TYPE.Line,
        position: 1,
        icon: '',
        isRecommended: false,
        recommendedText: recommendedText,
        reportDefinition: {},
        reportId:'',
        reportName:'',
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'Line'
        },
        visuliazationInfo: {
          name: 'For Line Try',
          rules: [
            { Number: '1', type: dateType.type, bgColor: dateType.color, icon: dateType.icon },
            { Number: '1 or 2', type: dimensionsType.type, bgColor: dimensionsType.color, icon: dimensionsType.icon },
            { Number: '1', type: measuresType.type, bgColor: measuresType.color, icon: measuresType.icon }
          ]
        }
      },
      {
        chartType: CHART_TYPE.Column,
        position: 2,
        icon: '',
        isRecommended: false,
        recommendedText: recommendedText,
        reportDefinition: {},
        reportId:'',
        reportName:'',
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'Column'
        },
        visuliazationInfo: {
          name: 'For Column Try',
          rules: [
            { Number: '1 or 2', type: dimensionsType.type, bgColor: dimensionsType.color, icon: dimensionsType.icon },
            { Number: '1', type: measuresType.type, bgColor: measuresType.color, icon: measuresType.icon }
          ]
        }
      },
      {
        chartType: CHART_TYPE.Bar,
        position: 3,
        icon: '',
        isRecommended: false,
        recommendedText: recommendedText,
        reportDefinition: {},
        reportId:'',
        reportName:'',
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'Bar'
        },
        visuliazationInfo: {
          name: 'For Bar Try',
          rules: [
            { Number: '1 or 2', type: dimensionsType.type, bgColor: dimensionsType.color, icon: dimensionsType.icon },
            { Number: '1', type: measuresType.type, bgColor: measuresType.color, icon: measuresType.icon }
          ]
        }
      },
      {
        chartType: CHART_TYPE.Area,
        position: 4,
        icon: '',
        isRecommended: false,
        recommendedText: recommendedText,
        reportDefinition: {},
        reportId:'',
        reportName:'',
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'Area'
        },
        visuliazationInfo: {
          name: 'For Area Try',
          rules: [
            { Number: '1 or more', type: dateType.type, bgColor: dateType.color, icon: dateType.icon },
            { Number: '2', type: dimensionsType.type, bgColor: dimensionsType.color, icon: dimensionsType.icon },
            { Number: '1', type: measuresType.type, bgColor: measuresType.color, icon: measuresType.icon }
          ]
        }
      },
      {
        chartType: CHART_TYPE.Pie,
        position: 5,
        icon: '',
        isRecommended: false,
        recommendedText: recommendedText,
        reportDefinition: {},
        reportId:'',
        reportName:'',
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'Pie'
        },
        visuliazationInfo: {
          name: 'For Pie Try',
          rules: [
            { Number: '1', type: dimensionsType.type, bgColor: dimensionsType.color, icon: dimensionsType.icon },
            { Number: '1', type: 'Positive Measure', bgColor: '#295599', icon: measuresType.icon }
          ]
        }
      },
      {
        chartType: CHART_TYPE.Funnel,
        position: 6,
        icon: '',
        isRecommended: false,
        recommendedText: recommendedText,
        reportDefinition: {},
        reportId:'',
        reportName:'',
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'Funnel'
        },
        visuliazationInfo: {
          name: 'For Funnel Try',
          rules: [
            { Number: '1 or 2', type: dimensionsType.type, bgColor: dimensionsType.color, icon: dimensionsType.icon },
            { Number: '1 or more', type: 'Measures', bgColor: measuresType.color, icon: measuresType.icon }
          ]
        }
      },
      {
        chartType: CHART_TYPE.Donut,
        position: 7,
        icon: '',
        isRecommended: false,
        recommendedText: recommendedText,
        reportDefinition: {},
        reportId:'',
        reportName:'',
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'Donut'
        },
        visuliazationInfo: {
          name: 'For Donut Try',
          rules: [
            {
              Number: '2 or more',
              type: dimensionsType.type,
              bgColor: dimensionsType.color,
              icon: dimensionsType.icon
            },
            { Number: '1 or more', type: 'Measures', bgColor: measuresType.color, icon: measuresType.icon }
          ]
        }
      },
      {
        chartType: CHART_TYPE.Combination,
        position: 8,
        icon: '',
        isRecommended: false,
        reportDefinition: {},
        recommendedText: recommendedText,
        reportId:'',
        reportName:'',
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'Combination'
        },
        visuliazationInfo: {
          name: 'For Combination Try',
          rules: [
            { Number: '1', type: dimensionsType.type, bgColor: dimensionsType.color, icon: dimensionsType.icon },
            { Number: '2 or more', type: measuresType.type, bgColor: measuresType.color, icon: measuresType.icon }
          ]
        }
      },
      {
        chartType: CHART_TYPE.TreeMap,
        position: 9,
        icon: '',
        isRecommended: false,
        recommendedText: recommendedText,
        reportDefinition: {},
        reportId:'',
        reportName:'',
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'TreeMap'
        },
        visuliazationInfo: {
          name: 'For TreeMap Try',
          rules: [
            { Number: '2 or 3', type: dimensionsType.type, bgColor: dimensionsType.color, icon: dimensionsType.icon },
            { Number: '1 or more', type: measuresType.type, bgColor: measuresType.color, icon: measuresType.icon }
          ]
        }
      },
      {
        chartType: CHART_TYPE.Waterfall,
        position: 10,
        icon: '',
        isRecommended: false,
        recommendedText: recommendedText,
        reportDefinition: {},
        reportId:'',
        reportName:'',
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'Waterfall'
        },
        visuliazationInfo: {
          name: 'For Waterfall Try',
          rules: [
            { Number: '1', type: dimensionsType.type, bgColor: dimensionsType.color, icon: dimensionsType.icon },
            { Number: '1', type: measuresType.type, bgColor: measuresType.color, icon: measuresType.icon }
          ]
        }
      },
      {
        chartType: CHART_TYPE.Bubble,
        position: 11,
        icon: '',
        isRecommended: false,
        recommendedText: recommendedText,
        reportDefinition: {},
        reportId:'',
        reportName:'',
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'Bubble'
        },
        visuliazationInfo: {
          name: 'For Bubble Try',
          rules: [
            {
              Number: '1 or more',
              type: dimensionsType.type,
              bgColor: dimensionsType.color,
              icon: dimensionsType.icon
            },
            { Number: '2', type: measuresType.type, bgColor: measuresType.color, icon: measuresType.icon }
          ]
        }
      },
      {
        chartType: CHART_TYPE.Sparkline,
        position: 12,
        icon: '',
        isRecommended: false,
        recommendedText: recommendedText,
        reportDefinition: {},
        reportId:'',
        reportName:'',
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'SparkLine'
        },
        visuliazationInfo: {
          name: 'For Sparkline Try',
          rules: [
            { Number: '1', type: dateType.type, bgColor: dateType.color, icon: dateType.icon },
            { Number: '2', type: dimensionsType.type, bgColor: dimensionsType.color, icon: dimensionsType.icon },
            { Number: '1', type: measuresType.type, bgColor: measuresType.color, icon: measuresType.icon }
          ]
        }
      },
      {
        chartType: CHART_TYPE.HeatMap,
        position: 13,
        icon: '',
        isRecommended: false,
        recommendedText: recommendedText,
        reportDefinition: {},
        reportId:'',
        reportName:'',
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'HeatMap'
        },
        visuliazationInfo: {
          name: 'For Heat Map Try',
          rules: [
            { Number: '2', type: dimensionsType.type, bgColor: dimensionsType.color, icon: dimensionsType.icon },
            { Number: '1', type: measuresType.type, bgColor: measuresType.color, icon: measuresType.icon }
          ]
        }
      },
      {
        chartType: CHART_TYPE.Scatter,
        position: 14,
        icon: '',
        isRecommended: false,
        recommendedText: recommendedText,
        reportDefinition: {},
        reportId:'',
        reportName:'',
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'Scatter'
        },
        visuliazationInfo: {
          name: 'For Scatter Try',
          rules: [
            {
              Number: '1 or more',
              type: dimensionsType.type,
              bgColor: dimensionsType.color,
              icon: dimensionsType.icon
            },
            { Number: '2', type: measuresType.type, bgColor: measuresType.color, icon: measuresType.icon }
          ]
        }
      },
      {
        chartType: CHART_TYPE.SolidGauge,
        position: 15,
        icon: '',
        isRecommended: false,
        recommendedText: recommendedText,
        reportDefinition: {},
        reportId:'',
        reportName:'',
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'SolidGauge'
        },
        visuliazationInfo: {
          name: 'For Solid Gauge Try',
          rules: [
            { Number: '1', type: dimensionsType.type, bgColor: dimensionsType.color, icon: dimensionsType.icon },
            { Number: '1 or more', type: measuresType.type, bgColor: measuresType.color, icon: measuresType.icon }
          ]
        }
      },
      {
        chartType: 'Grid',
        position: 100,
        icon: '',
        isRecommended: true,
        recommendedText: recommendedText,
        reportDefinition: {},
        isShow: true,
        isSave: false,
        isDashboardSave:false,
        sectionStyle: {
          backgroundImage: 'Grid'
        }
      },
    ];
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.Explore.js